import { BaseModel } from "sjs-base-model";

export default class ExternalInfoModel extends BaseModel {
    public readonly member: number | undefined = undefined;
    public readonly abi: string | undefined = undefined;

    constructor(data: Partial<ExternalInfoModel>) {
        super();

        this.update(data);
    }
}
